import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { hideLaunchEditOnMobile } from '../../app/utils/MobileHelper';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../ts/ServerApi/types/actionNames';
import { editWorkbookDraft } from '../actions/EditWorkbookAction';

export const EditWorkbookAction: IEntityAction<IContentInfo<'workbook'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editWorkbook_action,
  isVisible: () => !hideLaunchEditOnMobile(),
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => {
   return editWorkbookDraft(targetItems[0], 'ActionMenu_EditWorkbook');
  }
};
